import React, { Component } from 'react'
import { Input, Form, Button, Select, Radio, Divider, message, Spin, Modal } from 'antd'
import { app } from "../../app"
import api from "../../api"
import "./index.css"
import { div } from 'echarts-gl'
// import DebounceSelectBox from "./DebounceSelectBox"

const FormItem = Form.Item
const Option = Select.Option

class TETeamName extends Component {
    constructor(props) {
        super(props)
        this.state = {
            team_loading: false,
            search_type: 'bsrno', // 搜索类型
            // personnalChange: 0,
            all_team: [],
            statusList: [],
            // is_organization: 2,
            iivalue: '',
            isShow: false,
            currentName: {}, // 当前选中的接案人
            mainMan: '', // 主接案人
            nainMan: '', // 次接案人
            isMain: 1, // 1 主接案人 0 次接案人
            // selectValue: 2, // 是否体制内：0 否 1 是
            data: [
                {
                    key: '1',
                    name: 'John Brown',
                    age: 32,
                    address: 'New York No. 1 Lake Park',
                    tags: ['nice', 'developer'],
                },
                {
                    key: '2',
                    name: 'Jim Green',
                    age: 42,
                    address: 'London No. 1 Lake Park',
                    tags: ['loser'],
                },
                {
                    key: '3',
                    name: 'Joe Black',
                    age: 32,
                    address: 'Sidney No. 1 Lake Park',
                    tags: ['cool', 'teacher'],
                },
            ],
            columns: [
                {
                    title: '姓名',
                    dataIndex: 'name',
                    key: 'name',
                    width: 100,
                },
                {
                    title: '编号',
                    dataIndex: 'age',
                    key: 'age',
                    width: 100,
                },
            ]
        }
    }

    async componentDidMount() {
        this._isMounted = true
        // await this.teamData(); // 获取队伍信息
        await this.handleTeamStatusData()
        let { team, form } = this.props

        form.setFieldsValue({
            teamname: team ? (team.teamname || '') : '',
            team_code: team ? (team.team_code || '') : '',
            team_status: team ? (team.status || undefined) : '',
            // is_organization: team ? (team.is_organization.toString() || '') : ''
        });
        // console.log("team");
        // console.log(team);
        // const hide = message.loading("数据加载中..");
        // setTimeout(() => {
        //     this.setData({
        //         all_team: teamMember
        //     })
        //     hide();
        // }, 1000);
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    /**
     * 队伍列表数据
     **/
    handleTeamStatusData = async () => {
        let params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.TeamStatus, params)
        if (flag === 1) {
            this.setData({ statusList: data })
        } else {
            app.alert(msg, "error")
        }
    }

    async componentWillReceiveProps(props) {
        console.log("触发")
        let { team, form } = this.props
        console.log(team)
        if (JSON.stringify(team) !== JSON.stringify(props.team)) {
            props.form.setFieldsValue({
                teamname: props.team.teamname,
                team_code: props.team.team_code,
                team_status: props.team.status || undefined,
                // is_organization: props.team.is_organization.toString(),
            })
            this.setData({
                // is_organization: team.is_organization.toString(),
                mainMan: team.primary_accepter,
                nainMan: team.second_accepter,
            })
            // console.log(props.team.is_organization.toString());
        }
        // this.setData({
        //     all_team: teamMember
        // })
        // await this.teamData();
    }

    // 获取队员数据
    teamData = async () => {
        await this.setData({ team_loading: true })
        // message.info("队伍: " + this.props.team.teamname);
        // console.log("获取队伍数据");
        try {
            const params = {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                team_id: this.props.team.team_id,
                search_type: this.state.search_type,
                search_value: this.state.iivalue || '',
            };
            let { flag, data, msg } = await app.post(api.TeamMember, params);
            console.log("队伍数据：");
            console.log(data);
            if (flag !== 1) {
                app.alert(msg, "error");
                data = [];
            }
            this.setData({
                team_loading: false,
                all_team: data,
                currentName: {},
            });
            // this.set2(data);
        } catch (error) {

        }
        // this.setData({ team_loading: true }, async () => {

        // });
    }

    // 设置接案人
    setJieAn = async (e) => {
        if (this.state.currentName.vname === undefined) {
            message.error("请选择接案人");
            return false;
        }
        const hide = message.loading("loading..");
        // message.info("队伍: " + this.props.team.teamname);
        // console.log("获取队伍数据");
        try {
            const params = {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                team_id: this.props.team.team_id,
                volunteer_id: this.state.currentName.volunteer_id, // 接案人id
                type: e === 1 ? 1 : 2,
            };
            let { flag, msg } = await app.post(api.SetTeamMember, params);
            hide();
            const cur = this.state.currentName;
            let obj = {
                id: cur.volunteer_id,
                vname: cur.vname
            }
            if (flag === 1) {
                message.success(msg);
                if (e === 1) {
                    this.setData({
                        mainMan: obj
                    })
                } else {
                    this.setData({
                        nainMan: obj
                    })
                }
                setTimeout(() => {
                    this.setData({
                        isShow: false,
                        all_team: [],
                        currentName: {},
                        // nainMan
                    });
                    this.props.flushTeam();
                }, 800);
            } else {
                message.error(msg);
            }
        } catch (error) {

        }
        // this.setData({ team_loading: true }, async () => {

        // });
    }

    // set2 = (e) => {
    //     this.setData({
    //         all_team: e
    //     })
    // }

    // 搜索
    searchTeam = (e) => {
        e.preventDefault()
        message.info(this.state.iivalue);
    }

    setData = (data) => app.setStateSync(this, data)

    // shouldComponentUpdate(nextProps, nextState) {
    //     if (this.state.personnalChange !== nextState.personnalChange) {
    //         // 业务逻辑
    //         // ....            
    //         // 重渲染
    //         return true
    //     }
    // }

    /**
     * 编辑队伍信息
     * @param e
     */
    handleEditTeam = (e) => {
        e.preventDefault()
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                if (this.state.edit_loading) return false
                this.setData({ edit_loading: true })
                let { team } = this.props
                values.indexno = app.getData("indexno")
                values.account = app.getData("account")
                values.teamno = team.teamno
                let { flag, msg } = await app.post(api.EditTeamInfo, values)
                if (flag === 1) {
                    app.alert("修改成功", "success")
                    await this.props.flushTeam()
                } else {
                    app.alert(msg, "error")
                }
                this.setData({ edit_loading: false })
            }
        })
    }

    // 隐藏或显示设置接案人弹窗
    handleShow = async (e) => {
        // 打开按钮，判断主次
        // if (e === 1 || e === 0) {
        //     this.setData({
        //         isShow: true,
        //         isMain: e,
        //     })
        // } else {
        //     this.setData({
        //         isShow: false
        //     })
        // }
        if (e === 2) {
            if (this.state.isShow) {
                this.setData({
                    isShow: false,
                    currentName: {},
                })
            } else {
                this.setData({
                    isShow: true,
                    currentName: {},
                })
                await this.teamData();
            }
        } else {
            if (this.state.isShow) {
                this.setData({
                    isShow: false,
                    isMain: e,
                })
            } else {
                this.setData({
                    isShow: true,
                    isMain: e,
                })
                await this.teamData();
            }
        }

    }

    // 设置主次接案人
    handleOk = (e) => {
        console.log(e);
        // 设置主接案人
        if (e === 1) {
            this.setData({
                isShow: false,
            })
        } else {
            this.setData({
                isShow: false,
            })
        }
        // 调接口

    }

    // 搜索队员
    onChangee = async (e) => {
        // await this.teamData(e);
        // console.log(e.target.value);
        this.setData({
            iivalue: e.target.value
        })
    }

    // 改变搜索类型
    changeChangeType = (e) => {
        this.setData({
            search_type: e
        })
    }

    // 选中当前接案人
    selectCurrent = (e) => {
        this.setData({
            currentName: e
        })
    }

    // 设置主要接案人
    setMainMan = (e) => {
        this.setData({
            mainMan: e,
        })
    }

    // 设置次要接案人
    setNainMan = (e) => {
        this.setData({
            nainMam: e,
        })
    }

    // 设置是否在体制内
    setTizhi = async (e) => {
        // console.log(e)
        e.preventDefault()
        this.setData({ set_loading: true })
        let params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
            teamno: this.props.team.teamno,
            // is_organization: e.target.value
        }
        let { flag, msg } = await app.post(api.SetTeamInfo, params)
        if (flag === 1) {
            app.alert("修改成功", "success")
            // this.props.form.setFieldsValue({
            //     is_organization: e.target.value.toString()
            // });
            // this.setData({
            //     is_organization: e.target.value.toString()
            // })
            setTimeout(() => {
                this.props.flushTeam();
            }, 500);
        } else {
            app.alert(msg, "error")
        }
    }

    render() {
        let { form } = this.props,
            { getFieldDecorator, getFieldValue } = form,
            formItemLayout = {
                labelCol: { span: 6 },
                wrapperCol: { span: 13, offset: 1 },
            },
            { edit_loading, statusList, isShow, isMain, columns, mainMan, nainMan, data, currentName, all_team, team_loading } = this.state,
            rights = app.getData('rights');
        let teamposition_id = this.props.team ? (this.props.team.is_header === 1 ? 10 : -1) : 666;

        const children = [];
        for (let i = 10; i < 36; i++) {
            children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
        }
        const handleChange = (value) => {
            console.log(`Selected: ${value}`);
        };

        return (
            <div>
                {/*<Modal*/}
                {/*    title={<div>当前{isMain === 1 ? '主' : '次'}接案人：{*/}
                {/*        isMain === 1 ? (*/}
                {/*            this.props.team ? (Object.values(this.props.team.primary_accepter).length > 0 ? this.props.team.primary_accepter.vname : '--') : '--'*/}
                {/*        ) :*/}
                {/*            (this.props.team ? (Object.values(this.props.team.second_accepter).length > 0 ? this.props.team.second_accepter.vname : '--') : '--')*/}
                {/*    }</div>}*/}
                {/*    visible={isShow}*/}
                {/*    footer={false}*/}
                {/*    onOk={() => this.handleOk()}*/}
                {/*    width={768}*/}
                {/*    onCancel={() => this.handleShow(2)}*/}
                {/*>*/}
                {/*    <Input.Group compact>*/}
                {/*        <Select*/}
                {/*            defaultValue="存心编号"*/}
                {/*            style={{*/}
                {/*                width: 100,*/}
                {/*            }}*/}
                {/*            onChange={(e) => this.changeChangeType(e)}*/}
                {/*        >*/}
                {/*            <Option value="bsrno">存心编号</Option>*/}
                {/*            <Option value="vname">队员姓名</Option>*/}
                {/*        </Select>*/}
                {/*        <Input.Search*/}
                {/*            style={{*/}
                {/*                width: 300,*/}
                {/*                marginBottom: 10*/}
                {/*            }}*/}
                {/*            onPressEnter={(e) => this.teamData(e)}*/}
                {/*            onChange={(e) => this.onChangee(e)}*/}
                {/*            onSearch={(e) => this.teamData(e)}*/}
                {/*            placeholder='请输入关键字'*/}
                {/*        />*/}
                {/*        <Button type='text' style={{ textAlign: 'left', marginLeft: 8 }}>设置<span style={{ dusplay: 'inline-block', paddingLeft: 5, paddingRight: 5, color: currentName.vname ? '#1890ff' : '' }}>{currentName.vname || '--'}</span>为{isMain === 1 ? '主' : '次'}接案人</Button>*/}
                {/*        <Button type='primary' onClick={() => this.setJieAn(isMain)}>确定</Button>*/}
                {/*    </Input.Group>*/}

                {/*    <div>*/}
                {/*        <div className='nametitle'>搜索结果: </div>*/}
                {/*        <Spin spinning={team_loading} />*/}
                {/*        <div style={{*/}
                {/*            display: 'flex',*/}
                {/*            flexWrap: 'wrap',*/}
                {/*        }}>*/}
                {/*            {*/}
                {/*                all_team.map((item, index) => {*/}
                {/*                    return (*/}
                {/*                        <div*/}
                {/*                            className='nameitem'*/}
                {/*                            style={{*/}
                {/*                                color: item.vname === currentName.vname ? '#fff' : '',*/}
                {/*                                backgroundColor: item.vname === currentName.vname ? '#1890ff' : '',*/}
                {/*                            }}*/}
                {/*                            onClick={() => this.selectCurrent(item)}*/}
                {/*                            key={item.bsrno}>{item.vname}({item.bsrno})</div>*/}
                {/*                    )*/}
                {/*                })*/}
                {/*            }*/}
                {/*        </div>*/}
                {/*        <div className='iblock'>*/}
                {/*            共{all_team.length}条*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</Modal>*/}

                <div className="team-name">队伍设置</div>
                <Form style={{ width: '100%' }} onSubmit={this.handleEditTeam}>
                    <FormItem
                        {...formItemLayout}
                        label="修改队伍名称"
                    >{getFieldDecorator('teamname', {
                        rules: [{
                            required: true, message: '请填写队伍名称！',
                        }]
                    })(
                        <Input />
                    )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                        label="修改队伍编码"
                    >{getFieldDecorator('team_code', {
                        rules: [{
                            required: true, message: '请填写队伍编码！',
                        }]
                    })(
                        <Input />
                    )}
                        <span style={{color: 'red'}}>注：队伍编码用于自动生成存心编号，统一设置为2位大写字母</span>
                    </FormItem>
                    {/*{*/}
                    {/*    '12'.indexOf(rights) !== -1 ? (*/}
                    {/*        <FormItem*/}
                    {/*            {...formItemLayout}*/}
                    {/*            label="队伍状态"*/}
                    {/*        >{getFieldDecorator('team_status', {*/}
                    {/*            rules: [{*/}
                    {/*                required: true, message: '请选择队伍状态！',*/}
                    {/*            }]*/}
                    {/*        })(*/}
                    {/*            <Select style={{ width: '60%' }} placeholder="请选择">*/}
                    {/*                {*/}
                    {/*                    statusList.map((s, i) => {*/}
                    {/*                        return (*/}
                    {/*                            <Option key={i} value={s.id}>{s.type_name}</Option>*/}
                    {/*                        )*/}
                    {/*                    })*/}
                    {/*                }*/}
                    {/*                /!*<Option value="6">正式队</Option>*!/*/}
                    {/*                /!*<Option value="5">筹备队</Option>*!/*/}
                    {/*                /!*<Option value="4">筹备组</Option>*!/*/}
                    {/*                /!*<Option value="7">职能部门</Option>*!/*/}
                    {/*                /!*<Option value="3">下架</Option>*!/*/}
                    {/*            </Select>*/}
                    {/*        )}*/}
                    {/*        </FormItem>*/}
                    {/*    ) : null*/}
                    {/*}*/}

                    {/*{*/}
                    {/*    getFieldValue('team_status') === '3' ? (*/}
                    {/*        <FormItem*/}
                    {/*            {...formItemLayout}*/}
                    {/*            label="下架原因"*/}
                    {/*        >{getFieldDecorator('reason', {*/}
                    {/*            rules: [{*/}
                    {/*                required: true, message: '请填写原因！',*/}
                    {/*            }]*/}
                    {/*        })(*/}
                    {/*            <Input.TextArea rows={8} />*/}
                    {/*        )}*/}
                    {/*        </FormItem>*/}
                    {/*    ) : null*/}
                    {/*}*/}
                    <Form.Item
                        wrapperCol={{
                            offset: 7,
                        }}
                    >
                        <Button type="primary" htmlType="submit" loading={edit_loading}>提交</Button>
                    </Form.Item>

                    {/*{'1'.indexOf(rights) !== -1 ? <Divider /> : null}*/}

                    {/*{*/}
                    {/*    '1'.indexOf(rights) !== -1 ? (*/}
                    {/*        <FormItem {...formItemLayout}*/}
                    {/*            label="是否体制内"*/}
                    {/*        >*/}
                    {/*            {getFieldDecorator('is_organization', {*/}
                    {/*                rules: [{*/}
                    {/*                    required: false*/}
                    {/*                }]*/}
                    {/*            })(*/}
                    {/*                <Radio.Group onChange={(e) => this.setTizhi(e)}>*/}
                    {/*                    <Radio checked={this.state.is_organization === '1'} value='1'>是</Radio>*/}
                    {/*                    <Radio checked={this.state.is_organization === '0'} value='0'>否</Radio>*/}
                    {/*                </Radio.Group>*/}
                    {/*            )}*/}
                    {/*            /!* {JSON.stringify(this.props.team)} *!/*/}
                    {/*        </FormItem>*/}
                    {/*    ) : null*/}
                    {/*}*/}

                    {/*{'1'.indexOf(rights) !== -1 || teamposition_id == 10 ? <Divider /> : null}*/}

                    {/*{*/}

                    {/*    ('1'.indexOf(rights) !== -1 || teamposition_id == 10) ? (*/}
                    {/*        <FormItem {...formItemLayout}*/}
                    {/*            label="接案人管理"*/}
                    {/*            style={{ fontWeight: 600 }}*/}
                    {/*        ></FormItem>*/}
                    {/*    ) : null*/}
                    {/*}*/}

                    {/*{*/}
                    {/*    ('1'.indexOf(rights) !== -1 || teamposition_id == 10) ? (*/}
                    {/*        <FormItem {...formItemLayout}*/}
                    {/*            label="主接案人"*/}
                    {/*        >*/}
                    {/*            <Button key={mainMan} type='text' style={{ width: 150, textAlign: 'left' }}>{*/}
                    {/*                (this.props.team ? (Object.values(this.props.team.primary_accepter).length > 0 ? this.props.team.primary_accepter.vname + "(" + this.props.team.primary_accepter.bsrno + ")"*/}
                    {/*                    : '暂无') : '暂无')}</Button>*/}
                    {/*            <Button type='primary' style={{ marginLeft: 8 }} onClick={() => this.handleShow(1)}>{this.props.team ? (this.props.team.primary_accepter != {} ? '编辑' : '-- 请选择 --') : '-- 请选择 --'}</Button>*/}
                    {/*        </FormItem>*/}
                    {/*    ) : null*/}
                    {/*}*/}
                    {/*{*/}
                    {/*    ('1'.indexOf(rights) !== -1 || teamposition_id == 10) ? (*/}
                    {/*        <FormItem {...formItemLayout}*/}
                    {/*            label="次接案人"*/}
                    {/*        >*/}
                    {/*            <Button key={nainMan} type='text' style={{ width: 150, textAlign: 'left' }}>*/}
                    {/*                {*/}
                    {/*                    (this.props.team ? (Object.values(this.props.team.second_accepter).length > 0 ? this.props.team.second_accepter.vname + "(" + this.props.team.second_accepter.bsrno + ")"*/}
                    {/*                        : '暂无') : '暂无')}</Button>*/}
                    {/*            <Button type='primary' style={{ marginLeft: 8 }} onClick={() => this.handleShow(0)}>*/}
                    {/*                {this.props.team ? (this.props.team.second_accepter != {} ? '编辑' : '-- 请选择 --') : '-- 请选择 --'}*/}
                    {/*            </Button>*/}
                    {/*        </FormItem>*/}
                    {/*    ) : null*/}
                    {/*}*/}
                    {/*{*/}
                    {/*    ('1'.indexOf(rights) !== -1 || teamposition_id == 10) ? (*/}
                    {/*        <FormItem {...formItemLayout}*/}
                    {/*            label=""*/}
                    {/*            style={{ color: 'red' }}*/}
                    {/*            wrapperCol={{*/}
                    {/*                offset: 7,*/}
                    {/*            }}*/}
                    {/*        >*/}
                    {/*            接案人由队长设置，每支队伍可设置一主一次接案人；主接案人默认为队长，请各队自行设置*/}
                    {/*        </FormItem>*/}
                    {/*    ) : null*/}
                    {/*}*/}
                </Form>
            </div>
        )
    }
}

export default Form.create()(TETeamName)



// WEBPACK FOOTER //
// ./src/routes/ranks/TETeamName.jsx